import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import reportWebVitals from './reportWebVitals'
import store from './store'
import { Provider } from 'react-redux'
import App from 'App'

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element #root not found')
}

ReactDOM.createRoot(container).render(
  <Provider store={ store }>
    <App/>
  </Provider>
)

// Передайте сюда колбэк (например console.log), чтобы снимать метрики:
// https://bit.ly/CRA-vitals
reportWebVitals()
